import BUY_IT_AGAIN_BAG_PAGE_CONSTANTS from './BuyItAgainBagPage.constants';

const initialState = {
  openShopAllDrawer: false,
  biaProductAvailable:false
};

const BuyItAgainBagPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.OPEN_SHOP_ALL_BIA_DRAWER:
      return { ...state, openShopAllDrawer: action.payload };
    case BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.SET_BIA_PRODUCTS_AVAILABLE_PRODUCTS:
      return { ...state, biaProductAvailable: action.payload };

    default:
      return state;
  }
};

export default BuyItAgainBagPageReducer;
